import { atom } from "jotai";
import { TMarketItemWithFloorPrice } from "~/_types/TMarketItemWithFloorPrice";
import { InfiniteTypes } from "~/modules/Common/Utility/Infinite/types";

export type TMarketState = {
  liveItems: {
    resetCounter: number;
    originLiveItems: TMarketItemWithFloorPrice[] | null;
  };
  marketplaceVisibility: "PUBLIC" | "HIDDEN";
};

const INITIAL_STATE: TMarketState = {
  liveItems: {
    resetCounter: 0,
    originLiveItems: null,
  },
  marketplaceVisibility: "PUBLIC",
};

export const marketAtom = atom<TMarketState>(INITIAL_STATE);

export const writeResetCounterUpAtom = atom(null, (get, set) => {
  const prevState = get(marketAtom);

  set(marketAtom, {
    ...prevState,
    liveItems: {
      ...prevState.liveItems,
      resetCounter: prevState.liveItems.resetCounter + 1,
    },
  });
});
export const writeResetLiveItemsAtom = atom(null, (get, set) => {
  const prevState = get(marketAtom);

  set(marketAtom, {
    ...prevState,
    liveItems: {
      originLiveItems: null,
      resetCounter: prevState.liveItems.resetCounter + 1,
    },
  });
});
export const writeSetLiveItemsAtom = atom(
  null,
  (get, set, payload: { items: TMarketItemWithFloorPrice[] }) => {
    const prevState = get(marketAtom);

    set(marketAtom, {
      ...prevState,
      liveItems: {
        ...prevState.liveItems,
        originLiveItems: payload.items,
      },
    });
  },
);
export const writeMergeLiveItemsAtom = atom(
  null,
  (
    get,
    set,
    payload: {
      items: TMarketItemWithFloorPrice[];
      direction: InfiniteTypes["direction"];
    },
  ) => {
    const prevState = get(marketAtom);

    set(marketAtom, {
      ...prevState,
      liveItems: {
        ...prevState.liveItems,
        originLiveItems:
          payload.direction === "top"
            ? [...payload.items, ...(prevState.liveItems.originLiveItems ?? [])]
            : [
                ...(prevState.liveItems.originLiveItems ?? []),
                ...payload.items,
              ],
      },
    });
  },
);
export const writeSetMarketVisibilityAtom = atom(
  null,
  (get, set, payload: { visibility: "PUBLIC" | "HIDDEN" }) => {
    const prevState = get(marketAtom);

    set(marketAtom, {
      ...prevState,
      marketplaceVisibility: payload.visibility,
    });
  },
);
